export const getSubmissionErrors = (error) => {
  const errors = {}
  error?.response?.data?.errors?.map((err) => {
    errors[err.param] = err.msg
  })
  return errors
}
